var site = site || {};

site.userInfoCookie = site.userInfoCookie || {};
site.userInfoCookie.getValue =
  site.userInfoCookie.getValue ||
  function () {
    return '';
  };
(function ($) {
  Drupal.behaviors.loyaltyDynamicJoinForm = {
    attach: function () {
      var signedIn = site.userInfoCookie.getValue('signed_in') - 0;
      var isLoyalty = site.userInfoCookie.getValue('is_loyalty_member') - 0;

      if (signedIn && isLoyalty) {
        $('.js-guest').addClass('hidden');
        $('.js-logged-in-non-loyalty').addClass('hidden');
        $('.js-logged-in-loyalty').removeClass('hidden');
      } else if (signedIn && !isLoyalty) {
        $('.js-guest').addClass('hidden');
        $('.js-logged-in-loyalty').addClass('hidden');
        $('.js-logged-in-non-loyalty').removeClass('hidden');
      } else {
        $('.js-logged-in-loyalty').addClass('hidden');
        $('.js-logged-in-non-loyalty').addClass('hidden');
        $('.js-guest').removeClass('hidden');
      }
    }
  };
})(jQuery);
